import React, { useRef, useEffect } from "react";
import { useStyles } from "../styles/styles";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import Box from '@mui/material/Box';

const Dob = (props) => {
    const dob = props.dob;
    const setDob = props.setDob;
    const required = props.required;
    const errorId = props.errorId;
    const classes = useStyles;

    const descriptionId = "dob-dialog-desc";
    const helperId = "dob-format-helper";

    const pickerRef = useRef(null);

    useEffect(() => {
        if (pickerRef.current) {
            pickerRef.current.focus();
        }
    }, []);

    return (
        <>
            <FormControl fullWidth sx={classes.formControl}>
                <FormLabel required={required} shrink={true} sx={classes.inputLabel} htmlFor='dob'>
                    Date of Birth <span style={{ fontSize: '0.85em', fontWeight: 'normal' }}>(MM/DD/YYYY)</span>
                </FormLabel>
                <Box sx={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}>
                    <span id={descriptionId}>
                        Select your date of birth. Month, day, and year are required.
                    </span>
                    <span id={helperId}>
                        Format: MM/DD/YYYY
                    </span>
                </Box>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        name='dob'
                        disableFuture={true}
                        defaultValue={null}
                        value={dob}
                        onChange={(newValue) => {
                            setDob(newValue)
                        }}
                        inputRef={pickerRef}
                        slotProps={{
                            textField: {
                                id: 'dob',
                                placeholder: "MM/DD/YYYY",
                                sx: {
                                    '& input::placeholder': {
                                        color: '#767676',
                                        opacity: 1
                                    }
                                },
                                inputProps: {
                                    sx: classes.textbox,
                                    "aria-label": "Date of birth, MM/DD/YYYY",
                                    "aria-describedby": `${descriptionId} ${helperId}${errorId ? ` ${errorId}` : ''}`,
                                    "aria-required": "true"
                                }
                            }
                        }}
                    />
                </LocalizationProvider>
            </FormControl>
        </>
    );
};

export default Dob;
